export default "__VITE_ASSET__BBi8pAvZ__"